export enum LanguageDirection {
  DEFAULT = 'ltr',
  HE = 'rtl',
}
